<template>
  <div>
    <v-row no-gutters>
      <v-col class="pa-0" cols="12">
        <v-card-title class="pb-0">لوگو</v-card-title>
        <pic-selector
          class="pa-0 ma-0"
          style="padding: 0px !important"
          :default-cat-name="$t('logo')"
          :edit-name="false"
          :field.sync="tempInfo.logo"
          one-pic
          single
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="4" md="6">
        <v-text-field
          v-model="tempInfo.name"
          :error-messages="errors.name"
          dense
          label="نام"
          outlined
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="4" md="6">
        <v-text-field
          v-model="tempInfo.subtitle"
          :error-messages="errors.subtitle"
          dense
          label="زیرنام"
          outlined
        />
      </v-col>
      <v-col class="pa-2" cols="12" lg="4" md="6">
        <v-text-field
          v-model="tempInfo.user_limit"
          :error-messages="errors.user_limit"
          :min="1"
          clearable
          dense
          hide-spin-buttons
          label="تعداد شانس قابل استفاده هر کاربر"
          oninput="if(Number(this.value) < Number(this.min)) this.value = this.min;"
          outlined
          type="number"
        />
      </v-col>

      <v-col class="pa-2" lg="4" md="6">
        <color-picker
          v-model="tempInfo.background_color"
          label="رنگ پس‌زمینه"
        />
      </v-col>
    </v-row>

    <v-card-actions class="justify-end">
      <v-btn
        :loading="loading"
        color="success"
        min-width="110"
        outlined
        @click="saveInfo"
      >
        <v-icon left>mdi-content-save</v-icon>
        ثبت
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import PicSelector from "@/view/components/UploadCenter/picSelector.vue";
import ColorPicker from "@/view/pages/qrland/components/colorPicker.vue";
import { mapGetters } from "vuex";

export default {
  name: "LuckWheelInfo",

  components: {
    PicSelector,
    ColorPicker,
  },

  props: {
    value: Object,
  },

  data: () => ({
    tempInfo: {
      qr_id: null,
      logo: "",
      name: "",
      subtitle: "",
      background_color: "",
      user_limit: 1,
    },
    loading: false,
    errors: {},
  }),

  computed: {
    ...mapGetters("localstorage", ["createQrID"]),
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  mounted() {
    if (!this.tempInfo.background_color) {
      this.tempInfo.background_color = this.getRandomHex();
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal && typeof newVal === "object") {
          this.tempInfo = {
            qr_id: newVal.qr_id || null,
            logo: newVal.logo || "",
            name: newVal.name || "",
            subtitle: newVal.subtitle || "",
            background_color: newVal.background_color || this.getRandomHex(),
            user_limit: newVal.user_limit || 1,
          };
          this.$forceUpdate();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getRandomHex() {
      const r = Math.floor(Math.random() * 256)
        .toString(16)
        .padStart(2, "0");
      const g = Math.floor(Math.random() * 256)
        .toString(16)
        .padStart(2, "0");
      const b = Math.floor(Math.random() * 256)
        .toString(16)
        .padStart(2, "0");
      return `#${r}${g}${b}FF`.toUpperCase();
    },
    saveInfo() {
      this.loading = true;
      const obj = {
        qr_id: this.createQrID,
        logo: this.tempInfo.logo,
        name: this.tempInfo.name,
        subtitle: this.tempInfo.subtitle,
        background_color: this.tempInfo.background_color,
        user_limit: this.tempInfo.user_limit,
      };
      this.$api
        .post("/v1/testQr/wheels", obj)
        .then(({ data }) => {
          this.$root.$emit("setWheelId", data.data.id);
          this.computedValue = {
            ...data.data,
            logo: this.tempInfo.logo,
            name: this.tempInfo.name,
            subtitle: this.tempInfo.subtitle,
            background_color: this.tempInfo.background_color,
          };
          this.$toast.success("اطلاعات با موفقیت ذخیره شد.");
        })
        .catch(({ response }) => {
          this.errors = response.data?.errors;
          this.$toast.error(response.data?.message || "Invalid data!");
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped></style>
